module.exports = __webpack_public_path__ + "img/ro.a27430a1.svg";